import React from 'react';
import ReactDOM from 'react-dom';
import ImageGallery from 'react-image-gallery';

import $ from 'jquery';

import Service from './HomeBannerService';

import '../../../node_modules/react-image-gallery/styles/scss/image-gallery.scss';
import '../../../node_modules/react-modal-video/scss/modal-video.scss';
import './HomeBanner.scss';
import ModalVideo from 'react-modal-video';
import ReactModal from 'react-modal';

const reactModalStyles = {
    content: {
        top: '50%',
        left: '0',
        right: '0',
        bottom: '0',
        background: '#173e6e'
    }
};

export default class HomeBanner extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            isOpen: false,
            videoId: null,
            videoType: null,
            showModal: false,
            modalText: ""
        };

        this.renderItem = this.renderItem.bind(this);
        this.openModal = this.openModal.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    openModal(videoId, videoType) {
        this.setState({ videoId: videoId });
        this.setState({ isOpen: true });
        this.setState({ videoType: videoType });
    }

    handleOpenModal(modalText) {
        this.setState({ modalText: modalText });
        this.setState({ showModal: true });
    }

    handleCloseModal() {
        this.setState({ showModal: false });
    }

    render() {
        let hasMultipleSlides = this.state.items && this.state.items.length > 1;
        return (
            <div>
                <ModalVideo channel={this.state.videoType} isOpen={this.state.isOpen} videoId={this.state.videoId} onClose={() => this.setState({ isOpen: false })} />
                <ReactModal isOpen={this.state.showModal} contentLabel="Minimal Modal Example" style={reactModalStyles} ariaHideApp={false}>
                    <img onClick={this.handleCloseModal} className="close-react-modal" src="../images/shared/close-react-modal.png" alt="play-icon" />
                    <p className="react-modal-text">{this.state.modalText}</p>
                </ReactModal>
                <div className="banner-wrapper">
                    <ImageGallery
                            items={this.state.items}
                            renderItem={this.renderItem}
                            showFullscreenButton={false}
                            showPlayButton={false}
                            autoPlay={true}
                            slideInterval={7000}
                            slideDuration={750}
                            showThumbnails={hasMultipleSlides}
                            renderThumbInner={this.renderThumbInner}
                    />
                </div>
            </div>
        );
    }
    renderThumbInner(item) { 
        return (<div><div class="image-gallery-thumbnail-label"></div></div>);
    }
    renderItem(item) {
        const divStyle = {
            backgroundImage: 'linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(' + item.image.websitePath + ')'
        };

        const divVideoStyle = {
            backgroundImage: 'linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(' + item.videoScreen + ')'
        };

        this.initPopover();

        return (
            <div className='banner-image-wrapper' style={item.videoScreen ? divVideoStyle : divStyle}>
                {
                    item.videoId &&
                    <div className='banner-video-play'>
                        <img onClick={() => this.openModal(item.videoId, item.videoType)} className="hidden-xs pos-center video-play" src="../images/shared/video-play-icon.svg" alt="play-icon" />
                    </div>
                }

                { item.videoId == null && 
                    <div className="banner-info">
                        <strong>{item.title}</strong>
                        <p className="wysiwyg-content" dangerouslySetInnerHTML={{ __html: item.subtitle }}></p>
                        {
                            item.buttonLink && item.buttonText && item.openNewBlank &&
                        <a className="banner-btn alert-btn apply-btn" href={item.buttonLink}  target="_blank" rel="noopener">{item.buttonText}</a>
                    }
                    {
                        (item.disclaimText && !item.fullDisclaimText) &&
                        <p className="landing-disclaim">{item.disclaimText}</p>
                    }
                    {
                        (item.disclaimText && item.fullDisclaimText) &&
                        <span>
                            <p className="landing-disclaim desktop-view">{item.disclaimText}
                                <a className="popover-banner" href="#" data-placement="top" data-toggle="popover" data-content={item.fullDisclaimText}>
                                    <img className="icon-info" src="../images/shared/icon-info-24.png" alt="info" />
                                </a>
                            </p>
                            <p className="landing-disclaim mobile-view">
                                <a className="popover-banner" onClick={() => this.handleOpenModal(item.fullDisclaimText)}>
                                    {item.disclaimText}
                                </a>
                            </p>
                        </span>
                    }
                    {
                        item.buttonLink && item.buttonText && !item.openNewBlank &&
                        <a className="banner-btn alert-btn apply-btn" href={item.buttonLink}>{item.buttonText}</a>
                    }
                    </div>
                }
                {
                    item.videoId &&
                    <div className="banner-info">
                        <strong>{item.title}</strong>
                        <p className="wysiwyg-content" dangerouslySetInnerHTML={{ __html: item.subtitle }}></p>
                        <a onClick={() => this.openModal(item.videoId, item.videoType)} className="visible-xs-flex banner-btn alert-btn apply-btn">PLAY VIDEO</a>
                    </div>
                }
            </div>
        );
           
    }

    loadData() {
        Service.getSliderItems()
            .then(res => {
                this.setState({
                    items: res
                });
            });
    }

    initPopover() {
        $(document).ready(function () {
            $('.popover-banner').popover();
        });
    }
}

ReactDOM.render(<HomeBanner />, document.getElementById('homeBanner'));



// WEBPACK FOOTER //
// ./Src/Home/HomeBanner/HomeBanner.jsx